"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "merlino": {
    "3fbb04a7": [{
      "hkey": "d04e3e5b",
      "slug": "merlino",
      "name": "Merlino",
      "primary": true,
      "skipSearch": false
    }],
    "beccia": [{
      "hkey": "d04e3e5b",
      "slug": "merlino",
      "name": "Merlino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "fa70c148": [{
      "hkey": "d04e3e5b",
      "slug": "merlino",
      "name": "Merlino",
      "primary": true,
      "skipSearch": false
    }],
    "bezzecca": [{
      "hkey": "d04e3e5b",
      "slug": "merlino",
      "name": "Merlino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "b698bf97": [{
      "hkey": "d04e3e5b",
      "slug": "merlino",
      "name": "Merlino",
      "primary": true,
      "skipSearch": false
    }],
    "bocche-canal-marzano": [{
      "hkey": "d04e3e5b",
      "slug": "merlino",
      "name": "Merlino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "31dfc99f": [{
      "hkey": "d04e3e5b",
      "slug": "merlino",
      "name": "Merlino",
      "primary": true,
      "skipSearch": false
    }],
    "cazzanello": [{
      "hkey": "d04e3e5b",
      "slug": "merlino",
      "name": "Merlino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "61a2e19f": [{
      "hkey": "d04e3e5b",
      "slug": "merlino",
      "name": "Merlino",
      "primary": true,
      "skipSearch": false
    }],
    "molino-cazzanello": [{
      "hkey": "d04e3e5b",
      "slug": "merlino",
      "name": "Merlino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "30401e30": [{
      "hkey": "d04e3e5b",
      "slug": "merlino",
      "name": "Merlino",
      "primary": true,
      "skipSearch": false
    }],
    "pradazzo": [{
      "hkey": "d04e3e5b",
      "slug": "merlino",
      "name": "Merlino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "3601c10c": [{
      "hkey": "d04e3e5b",
      "slug": "merlino",
      "name": "Merlino",
      "primary": true,
      "skipSearch": false
    }],
    "risorgenza": [{
      "hkey": "d04e3e5b",
      "slug": "merlino",
      "name": "Merlino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "64dc07be": [{
      "hkey": "d04e3e5b",
      "slug": "merlino",
      "name": "Merlino",
      "primary": true,
      "skipSearch": false
    }],
    "torchio": [{
      "hkey": "d04e3e5b",
      "slug": "merlino",
      "name": "Merlino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;